// extracted by mini-css-extract-plugin
export default {"codeCell":"trpTm","copyIcon":"sO87y","titleCell":"TYvjY","statusCell":"BnB0y","preview":"yqY0W","title":"LoF8b","studentCell":"FW6uj","studentInner":"cHSGQ","studentEmail":"drtms"};